module.exports = __webpack_public_path__ + "assets/img/CA_Icon.7271b216.png";